import { serviceMaker, methods, api } from "./index.js";

export const GetGoodReceiptDetails = () =>
  serviceMaker(`/grn`, methods.GET, api.NGB);
export const getGrnTemplate = () =>
  serviceMaker(`/grn/template`, methods.GET, api.NGB);
// export const editGrnTemplate = data(id,data) => serviceMaker(`/grn/template/${id}`, methods.PUT, api.NGB, data);
export const getByIdGood = (id) =>
  serviceMaker(`/grn/${id}`, methods.GET, api.NGB);
export const getBySupplerId = (id) =>
  serviceMaker(`/items/supplier/${id}`, methods.GET, api.NGB);
export const getBySupplerdropdown = () =>
  serviceMaker(`/itemdetails/template/dropdown`, methods.GET, api.NGB);
export const saveGoods = (data) =>
  serviceMaker(`/grn`, methods.POST, api.NGB, data);
export const getGRNSupplierBySearch = (data) =>
  serviceMaker(
    `/grn/searching?supplierDescription=`,
    methods.GET,
    api.NGB,
    data
  );

export const editGrnTemplate = (id, data) =>
  serviceMaker(`/grn/${id}`, methods.PUT, api.NGB, data);

export const isPared = () => serviceMaker(`/items/all`, methods.GET, api.NGB);

export const deleteItemSale = (type, id) =>
  serviceMaker(`/${type}/delete/${id}`, methods.DELETE, api.NGB);

export const postItem = (data) =>
  serviceMaker(`/itemdetails`, methods.POST, api.NGB, data);
export const itemDetailsTemplate = () =>
  serviceMaker(`/itemdetails/template?grnId=`, methods.GET, api.NGB);

// Stock Transfer
export const viewMRNStockTransfer = () =>
  serviceMaker(`/mrn/view?limit=14&offset=0`, methods.GET, api.NGB);
export const viewGRVStockTransfer = () =>
  serviceMaker(`/grn?limit=14&offset=0`, methods.GET, api.NGB);
export const getByGrvId = (id) =>
  serviceMaker(`/grv/${id}`, methods.GET, api.NGB);
export const getByMrnId = (id) =>
  serviceMaker(`/mrn/${id}`, methods.GET, api.NGB);
export const getBySalesId = (id) =>
  serviceMaker(`/itemsales/sales/${id}`, methods.GET, api.NGB);
export const getMrnTemplate = () =>
  serviceMaker(`/mrn/template`, methods.GET, api.NGB);
export const postMrn = (data) =>
  serviceMaker(`/mrn`, methods.POST, api.NGB, data);
export const updateMrn = (id, data) =>
  serviceMaker(`/mrn/edit/${id}`, methods.PUT, api.NGB, data);
export const postGrv = (data) =>
  serviceMaker(`/grv`, methods.POST, api.NGB, data);
export const updateGrv = (id, data) =>
  serviceMaker(`/grv/edit/${id}`, methods.PUT, api.NGB, data);
export const postItemSale = (data) =>
  serviceMaker(`/itemsales`, methods.POST, api.NGB, data);
export const createIpPool = (data) =>
  serviceMaker(`/ippooling`, methods.POST, api.NGB, data);
export const postEditItemSale = (id, payload) =>
  serviceMaker(`/itemsales/edit/${id}`, methods.POST, api.NGB, payload);

export const addBulkUploads = (data) =>
  serviceMaker(
    "/datauploads/documents?isProcess=true",
    methods.POST,
    api.NGB,
    data
  );
export const downloadLogFile = (id) =>
  serviceMaker(
    `/datauploads/printlog/${id}?tenantIdentifier=default`,
    methods.GET,
    api.NGB
  );
export const downloadBulkFile = (id) =>
  serviceMaker(
    `/datauploads/print/${id}?tenantIdentifier=default`,
    methods.GET,
    api.NGB
  );

export const getBulkUploads = () =>
  serviceMaker(`/datauploads?limit=14&offset=0`, methods.GET, api.NGB);

export const itemSaleTemplateResource = () =>
  serviceMaker(`/itemsales/template`, methods.GET, api.NGB);
export const getMrnFalse = () =>
  serviceMaker(`/mrn/searching/1/?getAll=false`, methods.GET, api.NGB);
export const getMrnTrue = () =>
  serviceMaker(`/mrn/searching/1/?getAll=true`, methods.GET, api.NGB);
export const getOneTimeSaleItem = (id) =>
  serviceMaker(`/onetimesales/${id}/item`, methods.GET, api.NGB);
export const getTotalPricePost = (payload) =>
  serviceMaker(
    `/onetimesales/${payload.id}/totalprice?quantity=${payload.data.quantity}`,
    methods.POST,
    api.NGB,
    payload.data
  );
export const getMrnTemplateId = () =>
  serviceMaker(`/mrn/template/id`, methods.GET, api.NGB);

//Carton
export const saveCarton = (data) =>
  serviceMaker(`/mrn/movemrncarton`, methods.POST, api.NGB, data);
export const getcartoonNumbers = (id) =>
  serviceMaker(`/mrn/template/id?mrnId=${id}`, methods.GET, api.NGB);
export const getMrnSearch = (name) =>
  serviceMaker(`/mrn/searching/1/?officename=${name}`, methods.GET, api.NGB);

//Add Devices
export const getByItemDetailsdropdown = () =>
  serviceMaker(`/itemdetails/template/dropdown`, methods.GET, api.NGB);
export const getSqlSearch = () =>
  serviceMaker(`/itemdetails?sqlSearch=`, methods.GET, api.NGB);
export const getByItemDetailsTemplate = () =>
  serviceMaker(`/itemdetails/template`, methods.GET, api.NGB);
export const getMrnHistory = (id) =>
  serviceMaker(
    `/mrn/history?limit=14&offset=0&sqlSearch=${id}`,
    methods.GET,
    api.NGB
  );
export const saveQuality = (id, data) =>
  serviceMaker(`/itemdetails/${id}`, methods.PUT, api.NGB, data);
export const getByViewItemDetails = (id) =>
  serviceMaker(`/itemdetails/singleitem/${id}`, methods.GET, api.NGB);
export const deleteItemDetail = (id) =>
  serviceMaker(`/itemdetails/${id}`, methods.DELETE, api.NGB);

export const moveMrn = (data) =>
  serviceMaker(`/mrn/movemrn`, methods.POST, api.NGB, data);
export const movemrncarton = (data) =>
  serviceMaker(`/mrn/movemrncarton`, methods.POST, api.NGB, data);
export const moveItemSale = (data) =>
  serviceMaker(`/mrn/moveitemsale`, methods.POST, api.NGB, data);
export const moveGrv = (data) =>
  serviceMaker(`/mrn/movegrv`, methods.POST, api.NGB, data);
export const stockUploadfilter = (status, name, description) =>
  serviceMaker(
    `/itemdetails?status=${status}&entityName=${name}&itemDescription=${description}`,
    methods.GET,
    api.NGB,
  );

export const deleteVendor = (id) =>
  serviceMaker(`/vendormanagement/${id}`, methods.DELETE, api.NGB);
